/* unplugin-vue-components disabled */import script from "./GenerateItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./GenerateItem.vue?vue&type=script&lang=ts&setup=true"

import "./GenerateItem.vue?vue&type=style&index=0&id=237d5848&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237d5848"]])

export default __exports__